import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref } from 'vue';
import * as echarts from 'echarts';
import { useStore } from 'vuex';
export default {
  __name: 'RateLineView',
  setup(__props, {
    expose: __expose
  }) {
    const store = useStore();
    const phonenumber = ref(store.state.user.phonenumber);
    const chartContainer = ref(null);
    const chartContainer2 = ref(null);
    const chartContainer3 = ref(null);
    const flag = ref(true);
    const rateList = ref([{}]);
    const pushMatch = (list, goalLine) => {
      rateList.value = list;
      var yAxis1 = {
        type: 'value'
      };
      var yAxis2 = {
        type: 'value'
      };
      var yAxis3 = {
        type: 'value'
      };
      if (phonenumber.value == '15705840617' || flag.value) {
        let value1 = [];
        let value2 = [];
        let value3 = [];
        for (var i = 0; i < list.length; i++) {
          value1.push(Number(list[i].hadHRate.replace('%', '')));
          value1.push(Number(list[i].hsupportRate.replace('%', '')));
          value1.push(list[i].winrate);
          value2.push(Number(list[i].hadDRate.replace('%', '')));
          value2.push(Number(list[i].dsupportRate.replace('%', '')));
          value2.push(list[i].samerate);
          value3.push(Number(list[i].hadARate.replace('%', '')));
          value3.push(Number(list[i].asupportRate.replace('%', '')));
          value3.push(list[i].lostrate);
        }
        let maxValue1 = Math.ceil(Math.max(...value1));
        let minValue1 = Math.floor(Math.min(...value1));
        let maxValue2 = Math.ceil(Math.max(...value2));
        let minValue2 = Math.floor(Math.min(...value2));
        let maxValue3 = Math.ceil(Math.max(...value3));
        let minValue3 = Math.floor(Math.min(...value3));
        let data1 = Math.ceil((maxValue1 - minValue1) / 3);
        let data2 = Math.ceil((maxValue2 - minValue2) / 3);
        let data3 = Math.ceil((maxValue3 - minValue3) / 3);
        let max = Math.max(...[data1, data2, data3]);
        let maxValue = max * 3;
        let yAxis = {
          type: 'value',
          interval: 3,
          scale: true,
          axisLabel: {
            show: true
          },
          splitLine: {
            show: true
          },
          axisTick: {
            show: false //不显示刻度
          },
          axisLine: {
            show: false
          },
          nameTextStyle: {
            color: "#FFFFFF"
          },
          splitArea: {
            show: false
          }
        };
        yAxis1 = JSON.parse(JSON.stringify(yAxis));
        // yAxis1.min = minValue1
        // yAxis1.max = minValue1 + maxValue
        yAxis2 = JSON.parse(JSON.stringify(yAxis));
        // yAxis2.min = minValue2
        // yAxis2.max = minValue2 + maxValue
        yAxis3 = JSON.parse(JSON.stringify(yAxis));
        // yAxis3.min = minValue3
        // yAxis3.max = minValue3 + maxValue
      }
      footBallRate(list, yAxis1, goalLine);
      footBallRate2(list, yAxis2);
      footBallRate3(list, yAxis3, goalLine);
    };
    const footBallRate = async (list, yAxis, goalLine) => {
      try {
        let title = [];
        let value1 = [];
        let value2 = [];
        let value3 = [];
        let value4 = [];
        let legend = ['竞彩胜概率', '支持率', '威廉胜概率'];
        if (phonenumber.value == '15705840617' && goalLine < 0) {
          legend.push('亚盘');
        }
        for (var i = 0; i < list.length; i++) {
          title.push(list[i].dateString);
          value1.push(Number(list[i].hsupportRate.replace('%', '')));
          list[i].value = Number(list[i].hadHRate.replace('%', ''));
          if (phonenumber.value == '15705840617' || flag.value) {
            value2.push(list[i].hrate);
          } else {
            value2.push(Number(list[i].hsupportRate.replace('%', '')));
          }
          value3.push(list[i].winrate);
          if (phonenumber.value == '15705840617' && goalLine < 0) {
            value4.push(list[i].hostrate);
          }
        }
        const chart = echarts.init(chartContainer.value);
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              animation: false,
              axisPointer: {
                lineStyle: {
                  type: 'solid',
                  color: '#b2b5c1'
                }
              }
            },
            textStyle: {
              fontSize: '.24rem'
            },
            hideDelay: 0,
            padding: 5,
            formatter: function (params) {
              var data = params[0].data;
              var time = data.dateString;
              var total = data.hmoney + data.dmoney + data.amoney;
              var html = `${time}<br>胜：${data.hadH}   威胜：${data.win} <br>平：${data.hadD}   威平：${data.same} <br>负：${data.hadA}   威负：${data.lost} <br>总量：${total} <br>胜量：${data.hmoney} <br>胜支持率：${params[1].data} <br>胜威廉率：${data.winrate} <br>`;
              if (params[3] != undefined) {
                html = html + `主：${data.host}   盘：${data.handicap}   客：${data.guest}<br>`;
              }
              return html;
            }.bind(this)
          },
          xAxis: {
            type: 'category',
            data: title
          },
          legend: {
            data: legend
          },
          yAxis: yAxis,
          grid: {
            left: '10%',
            right: '3%',
            bottom: '8%'
          },
          series: [{
            name: '竞彩胜概率',
            data: list,
            type: 'line',
            smooth: true
          }, {
            name: '支持率',
            data: value2,
            type: 'line',
            smooth: true
          }, {
            name: '威廉胜概率',
            data: value3,
            type: 'line',
            smooth: true
          }, {
            name: '亚盘',
            data: value4,
            type: 'line',
            smooth: true
          }]
        };
        chart.setOption(option);
      } catch (error) {
        // 处理错误
        console.error(error);
      }
    };
    const footBallRate2 = async (list, yAxis) => {
      try {
        let title = [];
        let value1 = [];
        let value2 = [];
        let value3 = [];
        for (var i = 0; i < list.length; i++) {
          title.push(list[i].dateString);
          value1.push(Number(list[i].dsupportRate.replace('%', '')));
          list[i].value = Number(list[i].hadDRate.replace('%', ''));
          if (phonenumber.value == '15705840617' || flag.value) {
            value2.push(list[i].drate);
          } else {
            value2.push(Number(list[i].dsupportRate.replace('%', '')));
          }
          value3.push(list[i].samerate);
        }
        const chart = echarts.init(chartContainer2.value);
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              animation: false,
              axisPointer: {
                lineStyle: {
                  type: 'solid',
                  color: '#b2b5c1'
                }
              }
            },
            textStyle: {
              fontSize: '.24rem'
            },
            hideDelay: 0,
            padding: 5,
            formatter: function (params) {
              var data = params[0].data;
              var time = data.dateString;
              var total = data.hmoney + data.dmoney + data.amoney;
              var html = `${time}<br>胜：${data.hadH}   威胜：${data.win} <br>平：${data.hadD}   威平：${data.same} <br>负：${data.hadA}   威负：${data.lost} <br>总量：${total} <br>平量：${data.dmoney} <br>平支持率：${params[1].data} <br>平威廉率：${data.samerate} <br>`;
              return html;
            }.bind(this)
          },
          xAxis: {
            type: 'category',
            data: title
          },
          legend: {
            data: ['竞彩平概率', '支持率', '威廉平概率']
          },
          yAxis: yAxis,
          grid: {
            left: '10%',
            right: '3%',
            bottom: '8%'
          },
          series: [{
            name: '竞彩平概率',
            data: list,
            type: 'line',
            smooth: true
          }, {
            name: '支持率',
            data: value2,
            type: 'line',
            smooth: true
          }, {
            name: '威廉平概率',
            data: value3,
            type: 'line',
            smooth: true
          }]
        };
        chart.setOption(option);
      } catch (error) {
        // 处理错误
        console.error(error);
      }
    };
    const footBallRate3 = async (list, yAxis, goalLine) => {
      try {
        let title = [];
        let value1 = [];
        let value2 = [];
        let value3 = [];
        let value4 = [];
        let legend = ['竞彩负概率', '支持率', '威廉负概率'];
        if (phonenumber.value == '15705840617' && goalLine > 0) {
          legend.push('亚盘');
        }
        for (var i = 0; i < list.length; i++) {
          title.push(list[i].dateString);
          value1.push(Number(list[i].asupportRate.replace('%', '')));
          list[i].value = Number(list[i].hadARate.replace('%', ''));
          if (phonenumber.value == '15705840617' || flag.value) {
            value2.push(list[i].arate);
          } else {
            value2.push(Number(list[i].asupportRate.replace('%', '')));
          }
          value3.push(list[i].lostrate);
          if (phonenumber.value == '15705840617' && goalLine > 0) {
            value4.push(list[i].guestrate);
          }
        }
        const chart = echarts.init(chartContainer3.value);
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              animation: false,
              axisPointer: {
                lineStyle: {
                  type: 'solid',
                  color: '#b2b5c1'
                }
              }
            },
            textStyle: {
              fontSize: '.24rem'
            },
            hideDelay: 0,
            padding: 5,
            formatter: function (params) {
              var data = params[0].data;
              var time = data.dateString;
              var total = data.hmoney + data.dmoney + data.amoney;
              var html = `${time}<br>胜：${data.hadH}   威胜：${data.win} <br>平：${data.hadD}   威平：${data.same} <br>负：${data.hadA}   威负：${data.lost} <br>总量：${total} <br>负量：${data.amoney} <br>负支持率：${params[1].data} <br>负威廉率：${data.lostrate}`;
              if (params[3] != undefined) {
                html = html + `<br>主：${data.host}   盘：${data.handicap}   客：${data.guest}<br>`;
              }
              return html;
            }.bind(this)
          },
          xAxis: {
            type: 'category',
            data: title
          },
          legend: {
            data: legend
          },
          yAxis: yAxis,
          grid: {
            left: '10%',
            right: '3%',
            bottom: '8%'
          },
          series: [{
            name: '竞彩负概率',
            data: list,
            type: 'line',
            smooth: true
          }, {
            name: '支持率',
            data: value2,
            type: 'line',
            smooth: true
          }, {
            name: '威廉负概率',
            data: value3,
            type: 'line',
            smooth: true
          }, {
            name: '亚盘',
            data: value4,
            type: 'line',
            smooth: true
          }]
        };
        chart.setOption(option);
      } catch (error) {
        // 处理错误
        console.error(error);
      }
    };

    // 暴露给外部使用的函数
    __expose({
      pushMatch
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        ref_key: "chartContainer",
        ref: chartContainer,
        style: {
          "width": "90vw",
          "height": "300px"
        }
      }, null, 512), _createElementVNode("div", {
        ref_key: "chartContainer2",
        ref: chartContainer2,
        style: {
          "width": "90vw",
          "height": "300px"
        }
      }, null, 512), _createElementVNode("div", {
        ref_key: "chartContainer3",
        ref: chartContainer3,
        style: {
          "width": "90vw",
          "height": "300px"
        }
      }, null, 512)], 64);
    };
  }
};